export default __webpack_public_path__ + "static/media/Icon_Selected.4b7c1ef1.svg";